export default {
  QUERY_SPAREPARTS_TYPES: {
    url: '/api/v1/spare_parts/types',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  QUERY_SPAREPARTS_LIST: {
    url: '/api/v1/spare_parts',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  SAVE_SPAREPARTS: {
    url: '/api/v1/admin/spare_parts',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  PUT_SPAREPARTS: {
    url: '/api/v1/admin/spare_parts',
    method: 'put',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  DELETE_SPAREPARTS: {
    url: '/api/v1/admin/spare_parts',
    method: 'delete',
    disableSuccessMsg: false,
    disableErrorMsg: false
  }
}
